import
{
      Cell,
      LegendProps,
      Pie,
      PieChart,
      ResponsiveContainer,
} from "recharts";


const COLORS = ["#2962FF", "#86D9FF"];

const CustomLegend = (props: any) =>
{
      const { payload } = props;
      return (
            <ul
                  style={{
                        display: "flex",
                        gap: "20px",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        justifyContent: "center",
                  }}
            >
                  {payload?.map((entry: any, index: any) => (
                        <li
                              key={`item-${index}`}
                              style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                              <div
                                    style={{
                                          width: 10,
                                          height: 10,
                                          backgroundColor: entry.color,
                                          borderRadius: "50%",
                                    }}
                              />
                              <span className="text-white">{props?.t(entry.value)}</span>
                        </li>
                  ))}
            </ul>
      );
};

const PieChartComp = (props: any) =>
{
      return (
            <div className="w-full h-full flex flex-col items-center justify-center">
                  <ResponsiveContainer width="100%" height="80%">
                        <PieChart>
                              <Pie
                                    data={props?.data}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={80}
                                    paddingAngle={1}
                                    dataKey="value"
                                    stroke="none"
                                    label
                              >
                                    {props?.data.map((entry: any, index: any) => (
                                          <Cell
                                                key={`cell-${index}`}
                                                fill={COLORS[index % COLORS.length]}
                                          />
                                    ))}
                              </Pie>
                        </PieChart>
                  </ResponsiveContainer>

                  <div className="mt-2">
                        <CustomLegend
                              payload={props?.data.map((d: any, i: any) => ({ value: d.name, color: COLORS[i] }))}
                              t={props?.t}
                        />
                  </div>
            </div>
      );
};

export default PieChartComp;
